<template>
  <table class="info info--importdata">
    <thead>
      <tr>
        <th>Navn</th>
        <th>Administrationsveje</th>
        <th>Indholdsstoffer</th>
        <th />
      </tr>
    </thead>
    <tbody>
      <tr
        v-for="(item, itemIndex) in list"
        :key="itemIndex"
      >
        <td :style="{width: '20%'}">
          {{ item.name }}
        </td>
        <td :style="{width: '30%'}">
          <span
            class="badge"
            v-for="text in item.routeOfAdministrations"
            :key="text.referenceID"
          >{{ text.value }}</span>
        </td>
        <td :style="{width: '30%'}">
          <span
            class="badge"
            v-for="text in item.substances"
            :key="text.referenceID"
          >{{ text.value }}</span>
        </td>
        <td
          :style="{width: '5%'}"
          class="textRight"
        >
          <a
            href="#"
            @click.prevent="$emit('click', item)"
            class="underline"
          >Opret</a>
        </td>
      </tr>
    </tbody>
  </table>
</template>

<script>
export default {
    name: 'ImportPreparationNewList',
    props: {
        list: { type: Array, required: true },
    },
};
</script>

<style lang="scss" scoped>
.textRight {
    text-align: right;
}
</style>
